"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Category: ()=>Category,
    Checker: ()=>Checker,
    CustomersSortKey: ()=>CustomersSortKey,
    DeliveryFeeType: ()=>DeliveryFeeType,
    DeliveryMode: ()=>DeliveryMode,
    DistanceUnit: ()=>DistanceUnit,
    Effects: ()=>Effects,
    LoaderType: ()=>LoaderType,
    MenuSectionFilterType: ()=>MenuSectionFilterType,
    MenuSortKey: ()=>MenuSortKey,
    MenuType: ()=>MenuType,
    Modules: ()=>Modules,
    OrderType: ()=>OrderType,
    OrdersSortKey: ()=>OrdersSortKey,
    PaymentMethod: ()=>PaymentMethod,
    PlusDataLoaders: ()=>PlusDataLoaders,
    PotencyUnit: ()=>PotencyUnit,
    PricingType: ()=>PricingType,
    RestMethods: ()=>RestMethods,
    Services: ()=>Services,
    SortDirection: ()=>SortDirection,
    SpecialMenuType: ()=>SpecialMenuType,
    SpecialType: ()=>SpecialType,
    StrainType: ()=>StrainType,
    Subcategory: ()=>Subcategory,
    Transform: ()=>Transform,
    Versions: ()=>Versions
});
var Category;
(function(Category) {
    Category["Accessories"] = 'ACCESSORIES';
    Category["Apparel"] = 'APPAREL';
    Category["Cbd"] = 'CBD';
    Category["Clones"] = 'CLONES';
    Category["Concentrates"] = 'CONCENTRATES';
    Category["Edibles"] = 'EDIBLES';
    Category["Flower"] = 'FLOWER';
    Category["NotApplicable"] = 'NOT_APPLICABLE';
    Category["Orals"] = 'ORALS';
    Category["PreRolls"] = 'PRE_ROLLS';
    Category["Seeds"] = 'SEEDS';
    Category["Tinctures"] = 'TINCTURES';
    Category["Topicals"] = 'TOPICALS';
    Category["Vaporizers"] = 'VAPORIZERS';
})(Category || (Category = {}));
var Checker;
(function(Checker) {
    Checker["CheckLimits"] = 'checkLimits';
})(Checker || (Checker = {}));
var CustomersSortKey;
(function(CustomersSortKey) {
    CustomersSortKey["Email"] = 'EMAIL';
    CustomersSortKey["Name"] = 'NAME';
})(CustomersSortKey || (CustomersSortKey = {}));
var DeliveryFeeType;
(function(DeliveryFeeType) {
    DeliveryFeeType["Flat"] = 'FLAT';
    DeliveryFeeType["Percentage"] = 'PERCENTAGE';
})(DeliveryFeeType || (DeliveryFeeType = {}));
var DeliveryMode;
(function(DeliveryMode) {
    DeliveryMode["CityLimits"] = 'CITY_LIMITS';
    DeliveryMode["DrawnZones"] = 'DRAWN_ZONES';
    DeliveryMode["PostalCodes"] = 'POSTAL_CODES';
    DeliveryMode["Radius"] = 'RADIUS';
})(DeliveryMode || (DeliveryMode = {}));
var DistanceUnit;
(function(DistanceUnit) {
    DistanceUnit["Km"] = 'KM';
    DistanceUnit["Mi"] = 'MI';
})(DistanceUnit || (DistanceUnit = {}));
var Effects;
(function(Effects) {
    Effects["Calm"] = 'CALM';
    Effects["ClearMind"] = 'CLEAR_MIND';
    Effects["Creative"] = 'CREATIVE';
    Effects["Energetic"] = 'ENERGETIC';
    Effects["Focused"] = 'FOCUSED';
    Effects["Happy"] = 'HAPPY';
    Effects["Inspired"] = 'INSPIRED';
    Effects["Relaxed"] = 'RELAXED';
    Effects["Sleepy"] = 'SLEEPY';
    Effects["Uplifted"] = 'UPLIFTED';
})(Effects || (Effects = {}));
var LoaderType;
(function(LoaderType) {
    LoaderType["HasMany"] = 'HAS_MANY';
    LoaderType["HasOne"] = 'HAS_ONE';
    LoaderType["Join"] = 'JOIN';
})(LoaderType || (LoaderType = {}));
var MenuSectionFilterType;
(function(MenuSectionFilterType) {
    MenuSectionFilterType["CustomSection"] = 'CUSTOM_SECTION';
    MenuSectionFilterType["Specials"] = 'SPECIALS';
    MenuSectionFilterType["StaffPicks"] = 'STAFF_PICKS';
})(MenuSectionFilterType || (MenuSectionFilterType = {}));
var MenuSortKey;
(function(MenuSortKey) {
    MenuSortKey["MenuSetting"] = 'MENU_SETTING';
    MenuSortKey["Name"] = 'NAME';
    MenuSortKey["Popular"] = 'POPULAR';
    MenuSortKey["Potency"] = 'POTENCY';
    MenuSortKey["Price"] = 'PRICE';
})(MenuSortKey || (MenuSortKey = {}));
var MenuType;
(function(MenuType) {
    MenuType["Medical"] = 'MEDICAL';
    MenuType["Recreational"] = 'RECREATIONAL';
})(MenuType || (MenuType = {}));
var Modules;
(function(Modules) {
    Modules["Fraud"] = 'fraud';
    Modules["PaymentProcessing"] = 'paymentProcessing';
    Modules["Reporting"] = 'reporting';
})(Modules || (Modules = {}));
var OrderType;
(function(OrderType) {
    OrderType["CurbsidePickup"] = 'CURBSIDE_PICKUP';
    OrderType["Delivery"] = 'DELIVERY';
    OrderType["DriveThruPickup"] = 'DRIVE_THRU_PICKUP';
    OrderType["InStorePickup"] = 'IN_STORE_PICKUP';
    OrderType["Kiosk"] = 'KIOSK';
    OrderType["Pickup"] = 'PICKUP';
})(OrderType || (OrderType = {}));
var OrdersSortKey;
(function(OrdersSortKey) {
    OrdersSortKey["CreatedAt"] = 'CREATED_AT';
})(OrdersSortKey || (OrdersSortKey = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["Aeropay"] = 'AEROPAY';
    PaymentMethod["Alt_36"] = 'ALT_36';
    PaymentMethod["CanPay"] = 'CAN_PAY';
    PaymentMethod["Cash"] = 'CASH';
    PaymentMethod["Chase"] = 'CHASE';
    PaymentMethod["Check"] = 'CHECK';
    PaymentMethod["Credit"] = 'CREDIT';
    PaymentMethod["CreditCard"] = 'CREDIT_CARD';
    PaymentMethod["CreditCardAtDoor"] = 'CREDIT_CARD_AT_DOOR';
    PaymentMethod["CreditCardByPhone"] = 'CREDIT_CARD_BY_PHONE';
    PaymentMethod["Debit"] = 'DEBIT';
    PaymentMethod["DebitCard"] = 'DEBIT_CARD';
    PaymentMethod["DebitOnly"] = 'DEBIT_ONLY';
    PaymentMethod["DutchiePay"] = 'DUTCHIE_PAY';
    PaymentMethod["Hypur"] = 'HYPUR';
    PaymentMethod["InStoreCreditCard"] = 'IN_STORE_CREDIT_CARD';
    PaymentMethod["Linx"] = 'LINX';
    PaymentMethod["Merrco"] = 'MERRCO';
    PaymentMethod["Moneris"] = 'MONERIS';
    PaymentMethod["Paytender"] = 'PAYTENDER';
})(PaymentMethod || (PaymentMethod = {}));
var PlusDataLoaders;
(function(PlusDataLoaders) {
    PlusDataLoaders["ProductLoader"] = 'productLoader';
})(PlusDataLoaders || (PlusDataLoaders = {}));
var PotencyUnit;
(function(PotencyUnit) {
    PotencyUnit["Milligrams"] = 'MILLIGRAMS';
    PotencyUnit["MilligramsPerGram"] = 'MILLIGRAMS_PER_GRAM';
    PotencyUnit["MilligramsPerMl"] = 'MILLIGRAMS_PER_ML';
    PotencyUnit["Percentage"] = 'PERCENTAGE';
})(PotencyUnit || (PotencyUnit = {}));
var PricingType;
(function(PricingType) {
    PricingType["Medical"] = 'MEDICAL';
    PricingType["Recreational"] = 'RECREATIONAL';
})(PricingType || (PricingType = {}));
var RestMethods;
(function(RestMethods) {
    RestMethods["Del"] = 'del';
    RestMethods["Get"] = 'get';
    RestMethods["Patch"] = 'patch';
    RestMethods["Post"] = 'post';
    RestMethods["Put"] = 'put';
})(RestMethods || (RestMethods = {}));
var Services;
(function(Services) {
    Services["AcceptancesService"] = "AcceptancesService";
    Services["AccountBalancesService"] = "AccountBalancesService";
    Services["AchBatchesService"] = "AchBatchesService";
    Services["AchEntriesService"] = "AchEntriesService";
    Services["AchReturnReportsService"] = "AchReturnReportsService";
    Services["AchReturnsService"] = "AchReturnsService";
    Services["AchReversalsService"] = "AchReversalsService";
    Services["BankAccountsService"] = "BankAccountsService";
    Services["BillingAddressesService"] = "BillingAddressesService";
    Services["EnrollmentsService"] = "EnrollmentsService";
    Services["EntitiesService"] = "EntitiesService";
    Services["EntityLinkingsService"] = "EntityLinkingsService";
    Services["FraudAssessmentsService"] = "FraudAssessmentsService";
    Services["InstoreAnalyticsTokensService"] = "InstoreAnalyticsTokensService";
    Services["InstoreCartsService"] = "InstoreCartsService";
    Services["MessageProxyService"] = "MessageProxyService";
    Services["PaymentMethodsService"] = "PaymentMethodsService";
    Services["PaymentsService"] = "PaymentsService";
    Services["PreAuthsService"] = "PreAuthsService";
    Services["RegistrationService"] = "RegistrationService";
    Services["RetailerEnrollmentsService"] = "RetailerEnrollmentsService";
    Services["RetailerPaymentTypesService"] = "RetailerPaymentTypesService";
    Services["WalletsService"] = "WalletsService";
    Services["WidgetUrlService"] = "WidgetUrlService";
})(Services || (Services = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["Asc"] = 'ASC';
    SortDirection["Desc"] = 'DESC';
})(SortDirection || (SortDirection = {}));
var SpecialMenuType;
(function(SpecialMenuType) {
    SpecialMenuType["Both"] = 'BOTH';
    SpecialMenuType["Medical"] = 'MEDICAL';
    SpecialMenuType["Recreational"] = 'RECREATIONAL';
})(SpecialMenuType || (SpecialMenuType = {}));
var SpecialType;
(function(SpecialType) {
    SpecialType["Offer"] = 'OFFER';
    SpecialType["Sale"] = 'SALE';
})(SpecialType || (SpecialType = {}));
var StrainType;
(function(StrainType) {
    StrainType["FiftyToOne"] = 'FIFTY_TO_ONE';
    StrainType["FiveToOne"] = 'FIVE_TO_ONE';
    StrainType["HighCbd"] = 'HIGH_CBD';
    StrainType["Hybrid"] = 'HYBRID';
    StrainType["Indica"] = 'INDICA';
    StrainType["IndicaHybrid"] = 'INDICA_HYBRID';
    StrainType["NotApplicable"] = 'NOT_APPLICABLE';
    StrainType["OneToOne"] = 'ONE_TO_ONE';
    StrainType["Sativa"] = 'SATIVA';
    StrainType["SativaHybrid"] = 'SATIVA_HYBRID';
    StrainType["TenToOne"] = 'TEN_TO_ONE';
    StrainType["Thc"] = 'THC';
    StrainType["TwentyToOne"] = 'TWENTY_TO_ONE';
    StrainType["TwoToOne"] = 'TWO_TO_ONE';
})(StrainType || (StrainType = {}));
var Subcategory;
(function(Subcategory) {
    Subcategory["Applicators"] = 'APPLICATORS';
    Subcategory["Badder"] = 'BADDER';
    Subcategory["BakedGoods"] = 'BAKED_GOODS';
    Subcategory["Balms"] = 'BALMS';
    Subcategory["BathProducts"] = 'BATH_PRODUCTS';
    Subcategory["Batteries"] = 'BATTERIES';
    Subcategory["Blunts"] = 'BLUNTS';
    Subcategory["Budder"] = 'BUDDER';
    Subcategory["Bundles"] = 'BUNDLES';
    Subcategory["CapsulesTablets"] = 'CAPSULES_TABLETS';
    Subcategory["Cartridges"] = 'CARTRIDGES';
    Subcategory["Chews"] = 'CHEWS';
    Subcategory["Chocolates"] = 'CHOCOLATES';
    Subcategory["CleaningSolutions"] = 'CLEANING_SOLUTIONS';
    Subcategory["CookingBaking"] = 'COOKING_BAKING';
    Subcategory["Crumble"] = 'CRUMBLE';
    Subcategory["DabTools"] = 'DAB_TOOLS';
    Subcategory["Default"] = 'DEFAULT';
    Subcategory["Devices"] = 'DEVICES';
    Subcategory["Diamonds"] = 'DIAMONDS';
    Subcategory["Disposables"] = 'DISPOSABLES';
    Subcategory["Dissolvables"] = 'DISSOLVABLES';
    Subcategory["Drinks"] = 'DRINKS';
    Subcategory["Flavored"] = 'FLAVORED';
    Subcategory["FrozenTreats"] = 'FROZEN_TREATS';
    Subcategory["GiftCards"] = 'GIFT_CARDS';
    Subcategory["Glassware"] = 'GLASSWARE';
    Subcategory["Grinders"] = 'GRINDERS';
    Subcategory["Gummies"] = 'GUMMIES';
    Subcategory["HardCandy"] = 'HARD_CANDY';
    Subcategory["Hash"] = 'HASH';
    Subcategory["Herbal"] = 'HERBAL';
    Subcategory["Infused"] = 'INFUSED';
    Subcategory["InfusedBud"] = 'INFUSED_BUD';
    Subcategory["InfusedFlower"] = 'INFUSED_FLOWER';
    Subcategory["Isolate"] = 'ISOLATE';
    Subcategory["Kief"] = 'KIEF';
    Subcategory["Lighters"] = 'LIGHTERS';
    Subcategory["LipBalms"] = 'LIP_BALMS';
    Subcategory["LiveResin"] = 'LIVE_RESIN';
    Subcategory["Lotions"] = 'LOTIONS';
    Subcategory["Lozenges"] = 'LOZENGES';
    Subcategory["Lubricants"] = 'LUBRICANTS';
    Subcategory["Oil"] = 'OIL';
    Subcategory["Packs"] = 'PACKS';
    Subcategory["PapersRollingSupplies"] = 'PAPERS_ROLLING_SUPPLIES';
    Subcategory["Pet"] = 'PET';
    Subcategory["Pods"] = 'PODS';
    Subcategory["PreGround"] = 'PRE_GROUND';
    Subcategory["Rosin"] = 'ROSIN';
    Subcategory["Rso"] = 'RSO';
    Subcategory["Sauce"] = 'SAUCE';
    Subcategory["SavorySnacks"] = 'SAVORY_SNACKS';
    Subcategory["ShakeTrim"] = 'SHAKE_TRIM';
    Subcategory["Shatter"] = 'SHATTER';
    Subcategory["Singles"] = 'SINGLES';
    Subcategory["SmallBuds"] = 'SMALL_BUDS';
    Subcategory["Soaps"] = 'SOAPS';
    Subcategory["Sprays"] = 'SPRAYS';
    Subcategory["SticksRollOns"] = 'STICKS_ROLL_ONS';
    Subcategory["StorageContainers"] = 'STORAGE_CONTAINERS';
    Subcategory["Sublingual"] = 'SUBLINGUAL';
    Subcategory["Suckers"] = 'SUCKERS';
    Subcategory["Sugar"] = 'SUGAR';
    Subcategory["Suppositories"] = 'SUPPOSITORIES';
    Subcategory["TopicalOils"] = 'TOPICAL_OILS';
    Subcategory["TransdermalPatches"] = 'TRANSDERMAL_PATCHES';
    Subcategory["Trays"] = 'TRAYS';
    Subcategory["Unflavored"] = 'UNFLAVORED';
    Subcategory["Wax"] = 'WAX';
})(Subcategory || (Subcategory = {}));
var Transform;
(function(Transform) {
    Transform["CheckoutTransform"] = 'checkoutTransform';
})(Transform || (Transform = {}));
var Versions;
(function(Versions) {
    Versions["V1"] = 'v1';
    Versions["V2"] = 'v2';
    Versions["V3"] = 'v3';
    Versions["V4"] = 'v4';
})(Versions || (Versions = {}));
